import i18n from '@/core/translations/i18n';
import { BackOfficePermissionRoleClaim } from '@/../client-generator/generated-clients/user';

export default [
  {
    name: 'page-customers',
    faIcon: 'users',
    label: i18n.global.t('clients'),
    allowedRoles: ['Administrator'], //
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_CLIENTS],
  },
  {
    name: 'page-jobtasks-list',
    faIcon: 'briefcase',
    label: i18n.global.t('tasks'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_JOBTASKS],
  },
  {
    name: 'page-sites-list',
    faIcon: 'map-marker-alt',
    label: i18n.global.t('sites'),
    allowedRoles: ['Administrator'], //
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_SITES],
  },
  {
    name: 'page-documents-list',
    faIcon: 'file',
    label: i18n.global.t('documents'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_DOCUMENTS],
  },
  {
    name: 'page-services-translations-list',
    faIcon: 'star',
    label: i18n.global.t('services'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_SERVICES],
  },
  {
    name: 'page-tickets-list',
    faIcon: 'comments',
    label: i18n.global.t('tickets'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_TICKETS],
  },
  {
    name: 'page-communications-list',
    faIcon: 'bullhorn',
    label: i18n.global.t('communications'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_COMUNICATIONS],
  },
  {
    name: 'page-contradictory-requests',
    faIcon: 'calendar-check',
    label: i18n.global.t('contradictoryRequests'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_CONTRADICTORY_REQUESTS],
  },
  {
    name: 'page-personnel-list',
    faIcon: 'id-card-alt',
    label: i18n.global.t('personnel'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_EMPLOYEES],
  },
  {
    name: 'page-contacts-list',
    faIcon: 'address-book',
    label: `${i18n.global.t('contacts')} Pulinet`,
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_PULINET_CONTACTS],
  },
  {
    name: 'page-users',
    faIcon: 'users-cog',
    label: `${i18n.global.t('users')} Pulinet`,
    allowedRoles: ['Administrator'],
  },
  {
    name: 'page-sync',
    faIcon: 'sync',
    label: i18n.global.t('sync'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_SYNC],
  },
  {
    name: 'page-news',
    faIcon: 'newspaper',
    label: i18n.global.t('news'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_NEWS],
  },
  {
    name: 'page-survey-list',
    faIcon: 'poll-h',
    label: i18n.global.t('surveys'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_SURVEY],
  },
  {
    name: 'page-real-estate-fields',
    faIcon: 'ruler',
    label: i18n.global.t('qgis'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_QGIS],
  },
  {
    name: 'page-site-equipments-list',
    faIcon: 'tools',
    label: i18n.global.t('siteEquipments'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_EQUIPMENT],
  },
  {
    name: 'page-economics',
    faIcon: 'euro-sign',
    label: i18n.global.t('economics'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_ECONOMICS],
  },
  {
    name: 'page-variations',
    faIcon: 'calendar-pen',
    label: i18n.global.t('variations'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_ECONOMICS],
  },
  {
    name: 'page-rooms',
    faIcon: 'buildings',
    label: i18n.global.t('rooms'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_ECONOMICS],
  },
  {
    name: 'page-reports',
    faIcon: 'table',
    label: i18n.global.t('reports'),
    allowedRoles: ['Administrator'],
    allowedBackOfficeSubRoles: [BackOfficePermissionRoleClaim.USER_PERMISSION_REPORTS],
  },
];
